import { App } from 'vue'
import KoneTooltip from './kone-tooltip/index.vue'

export const setupCustomComponent = (app: App) => {
  // 注册组件
  app.component('kone-tooltip', KoneTooltip)
  // app.component('KoneTooltip', () => import('./kone-tooltip/index.vue'))
}
